import React, { useState } from 'react';

const Login = ({ handleLogin, loginError }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(username, password);
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <h2><b>LOGIN</b></h2>
      </div>
      <form className="login-form" onSubmit={handleSubmit}>
        <label style={{ fontWeight: 600 }}>Username :</label>
        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
        <br />
        <label style={{ fontWeight: 600 }}>Password :</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <br />
        <button type="submit"><b>Login</b></button>
        {loginError && <p className="login-error">{loginError}</p>}
      </form>
    </div>
  );
};

export default Login;



